import { updateDesignation } from "../../../services/designationServices";
import { useState } from "react";
import Cookies from "js-cookie"; // Add this import
import { Edit, Trash2 } from "lucide-react";
import EditDesignationModal from "./EditDesignationModal";
import toast from "react-hot-toast";

export const DesignationListTable = ({
  data = [],
  refetch,
  startIndex = 0,
  isHide = false,
  permissionsData,
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);


  const role = Cookies.get("role");

  let canEdit = false;
  let canDelete = false;

  if (role === "admin") {
    canEdit = true;
    canDelete = true;
  } else if (role === "maintainer") {
    const modulePermissions = permissionsData?.permissions?.find(
      (p) => p.module === "Designation List"
    );

    console.log(modulePermissions, "modulePermissions");

    canEdit = !!modulePermissions?.edit;
    canDelete = !!modulePermissions?.delete;
  }

  const showActions = canEdit || canDelete;

  const handleEditClick = (designation) => {
    if (!canEdit) {
      toast.error("You don't have permission to edit designations");
      return;
    }
    setSelectedDesignation(designation);
    setEditModalOpen(true);
  };

  const handleSaveEdit = async (updatedDesignation) => {
    if (!canEdit) {
      toast.error("You don't have permission to edit designations");
      return;
    }

    try {
      setIsLoading(true);
      await updateDesignation({
        name: updatedDesignation.name,
        id: updatedDesignation._id,
      });
      setEditModalOpen(false);
      setSelectedDesignation(null);
      toast.success("Designation updated successfully");
      refetch();
    } catch (err) {
      console.error("Update failed:", err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-x-auto min-h-80">
      <table className="min-w-full text-sm border border-gray-200">
        <thead className="bg-[#4F22D8] text-white text-sm rounded-t-xl">
          <tr>
            <th className="py-3 px-4 text-left font-semibold border-r border-gray-300">
              No
            </th>
            <th className="py-3 px-4 text-left font-semibold border-r border-gray-300">
              Designation name
            </th>
            {showActions && (
              <th className="py-3 px-4 text-left font-semibold">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td
                colSpan={showActions ? 3 : 2}
                className="text-center text-gray-500 py-4 border-t border-gray-200"
              >
                No designations found.
              </td>
            </tr>
          ) : (
            data.map((row, idx) => (
              <tr
                key={row._id}
                className="border-t border-gray-200 text-[15px] hover:bg-gray-50 transition-colors"
              >
                <td className="px-4 py-3 pl-6 text-black border-r border-gray-200">
                  {startIndex + idx + 1}
                </td>
                <td className="px-4 py-3 text-black border-r border-gray-200">
                  {row.name}
                </td>
                {showActions && (
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3 text-sm font-medium">
                      {canEdit && (
                        <button
                          onClick={() => handleEditClick(row)}
                          className="text-darkblue flex items-center gap-1 hover:text-blue-700 transition-colors"
                          disabled={isLoading || isHide}
                        >
                          <Edit size={14} />
                          Edit
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>

      {canEdit && (
        <EditDesignationModal
          isOpen={editModalOpen}
          onRequestClose={() => setEditModalOpen(false)}
          onSave={handleSaveEdit}
          designation={selectedDesignation}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
